// Copyright © 2022 Olo Inc. All rights reserved.
// This software is made available under the Olo Pay SDK License (See LICENSE.md file)
import type { NativeSyntheticEvent, ViewProps } from 'react-native';
import type {
  ApplePayButtonConfig,
  GooglePayButtonConfig,
} from 'src/definitions';

export interface DigitalWalletButtonNativeProps extends ViewProps {
  isEnabled?: boolean;
  googlePayConfig?: GooglePayButtonConfig;
  applePayConfig?: ApplePayButtonConfig;
  onClickedEvent(event: NativeSyntheticEvent<undefined>): void;
}
